import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";

const SECTIONS = [
  {
    n: "01",
    t: "Objet",
    p: "Les présentes conditions générales régissent les relations entre BSCOPTER — dont le siège social est établi Rue général Leman 51, 4340 Awans, Belgique, représentée par M. Bairin Jordy (ci-après « la société ») — et toute personne physique ou morale (ci-après « le client ») souscrivant à une prestation de vol en hélicoptère.",
  },
  {
    n: "02",
    t: "Réservation",
    p: "La réservation devient ferme dès réception du paiement ou de l'acompte demandé. Un bon de commande ou une confirmation par email fait foi. Toute réservation implique l'acceptation pleine et entière des présentes conditions.",
  },
  {
    n: "03",
    t: "Prix",
    p: "Les prix sont indiqués TTC. Ils correspondent à un vol complet, tous passagers compris, hors prestations spécifiques (vidéo, décoration, transport annexe) qui font l'objet d'un devis dédié.",
  },
  {
    n: "04",
    t: "Conditions de vol & sécurité",
    p: "Tout vol est soumis aux conditions météorologiques, aux règles de l'aviation civile et à l'appréciation du pilote commandant de bord. La sécurité prévaut en toute circonstance. Le pilote peut modifier, écourter ou annuler un vol.",
  },
  {
    n: "05",
    t: "Restrictions de poids",
    p: "Robinson R22 : poids du stagiaire limité à 90 kg. Robinson R44 : 120 kg par personne. Eurocopter AS350 : 150 kg par passager.",
  },
  {
    n: "06",
    t: "Annulation & report",
    p: "En cas d'annulation par le client à plus de 15 jours du vol, la somme est remboursée ou reportée. À moins de 15 jours, un report est proposé en fonction des disponibilités. En cas d'annulation par la société (météo, sécurité), un report sans frais est systématiquement proposé.",
  },
  {
    n: "07",
    t: "Validité des bons cadeaux",
    p: "Les bons cadeaux sont valables 12 mois à compter de leur date d'émission, sauf mention contraire. Passé ce délai, ils peuvent être prolongés sur demande.",
  },
  {
    n: "08",
    t: "Responsabilité",
    p: "La responsabilité de BSCOPTER est engagée dans les limites prévues par la législation aérienne applicable et par nos polices d'assurance en vigueur. Le client s'engage à respecter les consignes de sécurité communiquées avant chaque vol.",
  },
  {
    n: "09",
    t: "Données personnelles",
    p: "Les données collectées via le formulaire de réservation sont utilisées uniquement pour traiter la demande. Elles ne sont ni cédées, ni revendues. Vous disposez d'un droit d'accès, de rectification et de suppression en écrivant à info@bscopter.be.",
  },
  {
    n: "10",
    t: "Droit applicable",
    p: "Les présentes conditions sont régies par le droit belge. Tout litige relève de la compétence exclusive des tribunaux de l'arrondissement de Liège.",
  },
];

export default function CGV() {
  return (
    <div data-testid="page-cgv">
      <PageHeader
        overline="CGV"
        title="Conditions "
        italicWord="générales."
        lead="Les modalités qui encadrent nos vols. Résumé lisible, engagement clair."
      />
      <section className="py-16 md:py-24 bg-[color:var(--bs-bg)]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.n} delay={0.03 * i}>
              <article
                data-testid={`cgv-section-${s.n}`}
                className="border-t border-black/15 pt-8"
              >
                <div className="flex items-baseline gap-6">
                  <span className="font-display text-5xl font-light text-[color:var(--bs-gold)]">
                    {s.n}
                  </span>
                  <h2 className="font-display text-2xl md:text-3xl font-light">
                    {s.t}
                  </h2>
                </div>
                <p className="mt-5 text-[color:var(--bs-muted)] leading-relaxed font-light">
                  {s.p}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
